// EU-Aspect (EU-Aspekt) 1: n Action Field (Handlungsfeld) 1 : n Measure Types (Maßnahmentyp)

export const getValidActionIds = (euAspect: number) => {
  const actionFields = getActionField(euAspect);
  const actionFieldIds = actionFields.map((sel: ISelection) => Number(sel.id));
  return actionFieldIds;
}

export const getValidMeasureTypes = (actionField: number) => {
    const measureTypes = getMeasureType(actionField);
    const measureIds = measureTypes.map((sel: ISelection) => sel.id.toString());
    return measureIds;
}

export const measureTypeIsValid = (actionField: number, measureType: string) => {
  return getValidMeasureTypes(actionField).includes(measureType);
}

export const actionFieldIsValid = (euAspect: number, actionField: number) => {
  return getValidActionIds(euAspect).includes(actionField);
}

// Return action field from measure type
// one action field can have several measure types
export const getActionFieldFromMeasureType = (measureType: string) => {
  switch(measureType){
    case '301': return 11;
    case '301_2': return 11;
    case '302_1': return 11;
    case '302_2':  return 11;
    case '303_1':  return 11;
    case'303_2': return 11;
    case '304': return 11;
    case '309_1': return 11;
    case '309_2': return 11;
    case '305': return 12;
    case '309_3': return 12;
    case '306': return 13;
    case '307': return 13;
    case '308': return 13;
    case '310': return 21;
    case '311': return 21;
    case '312': return 21;
    case '313': return 21;
    case '314': return 21;
    case '315': return 22;
    case '315_J': return 22;
    case '316_1': return 22;
    case '316_2': return 22;
    case '316_2J': return 22;
    case '317': return 22;
    case '317_J': return 22;
    case '318': return 22;
    case '318_J': return 22;
    case '320': return 22;
    case '321': return 22;
    case '319': return 22;
    case '322': return 31;
    case '323': return 31
    case '325_1': return 31;
		case '325_2': return 32;
		case '324_1': return 33;
    case '324_2': return 33;
    case '324_3': return 33;
    case '324_4': return 33;
    case '324_5': return 33;
    case '324_6': return 33;
    case '324_7': return 33;
    case '326': return 34;
    case '327': return 41;
    case '328': return 41;
    case '501_2': return 51;
    case '501': return 52;
    case '502': return 52;
    case '503': return 52;
    case '504': return 52;
    case '505': return 52;
    case '506': return 52;
    case '507': return 52;
    case '508': return 52;
    case '509': return 52;
    case '511': return 52;
		case '329': return 61;
    case '7777': return 7777;
    default:
      return 61
  }
}

// Return eu aspect from action field
// one eu aspect can have several action fields
export const getEUAspectfromActionField = (id: number) => {
  switch(id){
    case 11:
      return 1;
    case 12:
      return 1;
    case 13:
      return 1;
    case 21:
      return 2;
    case 22:
      return 2;
    case 31:
      return 3;
    case 32:
      return 3;
    case 33:
      return 3;
    case 34:
      return 3;
    case 41:
      return 4;
    case 51:
      return 5;
    case 52:
      return 5;
    case 61:
      return 6;
    case 7777:
      return 7777;
    default:
      return 6
  }
}

export interface ISelection {
  id: number | string;
  displayName: string;
  explanation?: string;
}

export interface ISelectableValue {
  id: string | number;
  label: string; 
}

export const EU_ASPECT_TYPES = [
  {id: 1, displayName: 'Vermeidung'},
  {id: 2, displayName: 'Schutz'},
  {id: 3, displayName: 'Vorsorge'},
  {id: 4, displayName: 'Wiederherstellung / Regeneration und Überprüfung'},
  {id: 5, displayName: 'Konzeptionelle Maßnahmen'},
  {id: 6, displayName: 'Sonstiges'},
  {id: 7777, displayName: 'Verzicht auf die Meldung einer Maßnahme'}
]

export const getAreaDisplayName = (id: string) => {
  switch(id){
    case 'ALKIS_VG_ArL_Bezirke':
      return 'Ämter für Regionale Landesentwicklung';   
    case 'BSH_HunteWeserEms':
      return 'BSH Hunte Weser-Ems' 
    case 'DachverbandAllerBoehme':
      return 'Dachverband Aller-Böhme'
    case 'DachverbandHase':
      return 'Dachverband Hase'
    case 'Deichverbandsgebiete':
      return 'Deichverbände'
    case 'Einzugsgebiete_UHV':
      return 'Einzugsgebiete UHV'; 
    case 'Flussgebietseinheiten':
      return 'Flussgebietseinheiten';    
     case 'Gemeinden':
      return 'Gemeinden';    
    case 'Gewerbeaufsichtsamt':
      return 'Gewerbeaufsichtsämter'
    case 'GartowerDeichWasserverband':
      return 'Gartower Deich- und Wasserverband';
    case 'GLVSuedheide':
      return 'GLV Südheide';
    case 'Handwerkskammer':
      return 'Handwerkskammern'
    case 'KreisverbandWasserwirtschaft':
      return 'Kreisverband für Wasserwirtschaft Nienburg';
    case 'KreisverbandWBVWuemme':
      return 'Kreisverband WBV Wümme'; 
    case 'Land':
      return 'Land Niedersachsen';
    case 'Landkreise':
      return 'Landkreise';
    case 'Landwirtschaftskammer':
      return 'Landwirtschaftskammern'; 
    case 'Polizeidirektionen':
      return 'Polizeidirektionen'; 
    case 'Samtgemeinden':
    return 'Samtgemeinden'; 
    case 'WasserverbandPeine':
      return 'Wasserverband Peine'; 
    case 'WBVOtterndorf':
      return 'WBV Otterndorf'; 
    case 'ZweckverbandGrossraumBraunschweig':
      return 'Zweckverband Großraum Braunschweig';     
    default:
      return id;
  }
}

export const getEuAspectTypeName = (id: number) => {
  switch(id){
    case 1:
      return 'Vermeidung';
    case 2:
      return 'Schutz';
    case 3:
      return 'Vorsorge';
    case 4:
      return 'Wiederherstellung / Regeneration und Prüfung';
    case 5:
      return 'Konzeptionelle Maßnahmen';
    case 6:
      return 'Sonstiges';
    case 7777:
      return 'Verzicht auf die Meldung einer Maßnahme';
    default:
      return 'Sonstiges'
  }
}

export const getActionField = (euApectType: number) => {
  switch (euApectType){
    case 1: // Vermeidung
      return [
        {id: 11, displayName: 'Flächenvorsorge'},
        {id: 12, displayName: 'Vermeidung'},
        {id: 13, displayName: 'Bauvorsorge'}
      ]  as Array<ISelection>;
    case 2: // Schutz
      return [
        {id: 21, displayName: 'Natürlicher Wasserrückhalt'},
        {id: 22, displayName: 'Technischer Hochwasserschutz'}         
      ]  as Array<ISelection>;
    case 3: // Vorsorge
      return [
        {id: 31, displayName: 'Informationsvorsorge'},
        {id: 32, displayName: 'Verhaltensvorsorge'},
        {id: 33, displayName: 'Gefahrabwehr und Katastrophenschutz'},
        {id: 34, displayName: 'Risikovorsorge'}
      ] as Array<ISelection>;
    case 4: // Wiederherstellung / Regeneration und Prüfung
      return [
        {id: 41, displayName: 'Wiederherstellung/ Regeneration und Überprüfung'}  
      ]  as Array<ISelection>;
    case 5: // Konzeptionelle Maßnahmen
      return [
        {id: 51, displayName: 'Flächenvorsorge'} ,
        {id: 52, displayName: 'Konzeptionelle Maßnahmen'}
      ] as Array<ISelection>;
    case 6: // Sonstiges
      return [
        {id: 61, displayName: 'Sonstige'}  
      ] as Array<ISelection>;
    case 7777: // Sonstiges
      return [
        {id: 7777, displayName: 'Fehlmeldung'}  
      ] as Array<ISelection>;
    default:
      return Array<ISelection>();
  }
}

export const actionFields = [
  {id: 11, label: 'Flächenvorsorge'},
  {id: 12, label: 'Vermeidung'},
  {id: 13, label: 'Bauvorsorge'},
  {id: 21, label: 'Natürlicher Wasserrückhalt'},
  {id: 22, label: 'Technischer Hochwasserschutz'},
  {id: 31, label: 'Informationsvorsorge'},
  {id: 32, label: 'Verhaltensvorsorge'},
  {id: 33, label: 'Gefahrabwehr und Katastrophenschutz'},
  {id: 34, label: 'Risikovorsorge'},
  {id: 41, label: 'Wiederherstellung/ Regeneration und Überprüfung'},
  {id: 51, label: 'Flächenvorsorge'} ,
  {id: 52, label: 'Konzeptionelle Maßnahmen'},
  {id: 61, label: 'Sonstige'},  
  {id: 7777, label: 'Fehlmeldung'}  
]


export const getActionFieldName = (id: number) => {
  switch(id){
    case 11:
      return 'Flächenvorsorge';
    case 12:
      return 'Vermeidung';
    case 13:
      return 'Bauvorsorge';
    case 21:
      return 'Natürlicher Wasserrückhalt';
    case 22:
      return 'Technischer Hochwasserschutz';
    case 31:
      return 'Informationsvorsorge';
    case 32:
      return 'Verhaltensvorsorge';
    case 33:
      return 'Gefahrabwehr und Katastrophenschutz';
    case 34:
      return 'Risikovorsorge';
    case 41:
      return 'Wiederherstellung/ Regeneration und Überprüfung';
    case 51:
      return 'Flächenvorsorge';
    case 52:
      return 'Konzeptionelle Maßnahmen';
    case 61:
      return 'Sonstiges';
    case 7777:
      return 'Fehlmeldung';
    default:
      return 'Sonstiges'
  }
}

export const getMeasureTypeName = (id: string) => {
  switch(id){
    case '301': return 'Anpassung des Regionalen Raumordnungsprogramms';
    case '301_2': return 'Anpassung des Landesraumordnungsprogramms';
    case '302_1': return 'Vorläufige Sicherung der ÜSG (HQ100)';
    case '302_2':  return 'Festsetzung der ÜSG (HQ100)';
    case '303_1':  return 'Anpassung des Flächennutzungsplans';
    case'303_2': return 'Anpassung der Bebauungspläne';
    case '304': return 'Maßnahmen zur hochwasserangepassten Flächennutzung';
    case '309_1': return 'Anpassung des Landschaftsplans';
    case '309_2': return 'Anpassung des Landschaftsrahmenplans';
    case '305': return 'Entfernung/Rückbau von hochwasserempfindlichen Nutzungen bzw. Objekten in Überschwemmungsgebieten und/oder Verlegung in Gebiete mit niedrigerer Hochwasserwahrscheinlichkeit';
    case '309_3': return 'Maßnahmen zur Unterstützung der Vermeidung von Hochwasserrisiken/Erstellung von lokalen/regionalen Studien, Gutachten';
    case '306': return 'Hochwasserangepasstes Bauen und Sanieren';
    case '307': return 'Objektschutz (nachträglich) an Gebäuden und Infrastruktureinrichtungen';
    case '308': return 'Hochwasserangepasster Umgang mit wassergefährdenden Stoffen einschl. Beratung';
    case '310': return 'Hochwassermindernde Flächenbewirtschaftung';
    case '311': return 'Gewässer- und Auenrenaturierung (mit positiven Wirkungen auf den Hochwasserschutz)';
    case '312': return 'Minderung der Flächenversiegelung';
    case '313': return 'Regenwassermanagement';
    case '314': return 'Wiedergewinnung von natürlichen Rückhalteflächen';
    case '315': return 'Technischer Hochwasserrückhalt - Neubau/Erweiterung';
    case '315_J': return 'Technischer Hochwasserrückhalt - Neubau/Erweiterung gewidmeter Anlagen';
    case '316_1': return 'Neuaufstellung/Fortschreibung/Optimierung von Betriebsplänen';
    case '316_2': return 'Technischer Hochwasserrückhalt - Sanierung/Instandsetzung';
    case '316_2J': return 'Technischer Hochwasserrückhalt - Sanierung/Instandsetzung gewidmeter Anlagen';
    case '317': return 'Technischer Linienschutz - Neubau/Ausbau';
    case '317_J': return 'Technischer Linienschutz - Neubau/Ausbau gewidmeter Bauwerke';
    case '318': return 'Technischer Linienschutz - Sanierung/Instandsetzung';
    case '318_J': return 'Technischer Linienschutz - Sanierung / Instandsetzung gewidmeter Bauwerke';
    case '320': return 'Gewässerunterhaltung und Vorlandmanagement';
    case '321': return 'Hochwasserschutzkonzepte';
    case '319': return 'Vergrößerung des Hochwasser- /Abflussquerschnitts';
    case '322': return 'Hochwasser-/Sturmflutvorhersage und -meldung';
    case '323': return 'Kommunale Warn- und Informationssysteme';
    case '325_1': return 'Durchführung eines Audits Hochwasser';
		case '325_2': return 'Aufklärungsmaßnahmen über Hochwasserrisiken';
		case '324_1': return 'Katastrophenschutzpläne';
    case '324_2': return 'örtliche Alarm-/Einsatz- bzw. Gefahrenabwehrpläne Hochwasser';
    case '324_3': return 'Deichverteidigungsordnung';
    case '324_4': return 'Deichverteidigungspläne';
    case '324_5': return 'Übungen';
    case '324_6': return 'Schulungen (Hochwasserschutz/Deichverteidigung)';
    case '324_7': return 'Bereitstellung von Personalund Sachressourcen für das Krisenmanagement';
    case '326': return 'Risikovorsorge';
    case '327': return 'Schadensnachsorge';
    case '328': return 'Sonstige Maßnahmen aus dem Bereich Wiederherstellung, Regeneration und Überprüfung';
    case '501_2': return 'Aufstellung/Anpassung des Landschaftsprogramms';
    case '501': return 'Erstellung von landesweiten oder gebietsunabhängigen Konzeptionen/Studien/Gutachten (APSFR-unabhängig)';
    case '502': return 'Durchführung von Forschungs-, Entwicklungs- und Demonstrationsvorhaben';
    case '503': return 'Gebietsunabhängige oder landesweite Informations- und Fortbildungsmaßnahmen';
    case '504': return 'Gebietsunabhängige oder landesweite Beratungsmaßnahmen';
    case '505': return 'Einrichtung bzw. Anpassung von Förderprogrammen';
    case '506': return 'Freiwillige Kooperationen';
    case '507': return 'Zertifizierungssysteme';
    case '508': return 'Vertiefende Untersuchungen und Kontrollen';
    case '509': return 'Landesweite Untersuchungen zum Klimawandel';
    case '511': return 'Unterstützung eines kommunalen Starkregenrisikomanagements';
		case '329': return 'Sonstige Maßnahmen';
    case '7777': return 'Fehlmeldung'
    default:
      return 'Sonstiges'
  }
}

export const getMeasureType = (actionField: number) => {
  switch (actionField){
    case 11: // Vermeidung - Flächenvorsorge
      return [
        {id: '301', displayName: 'Anpassung des Regionalen Raumordnungsprogramms'},
        {id: '301_2', displayName: 'Anpassung des Landesraumordnungsprogramms'},
        {id: '302_1', displayName: 'Vorläufige Sicherung der ÜSG (HQ100)'},
        {id: '302_2', displayName: 'Festsetzung der ÜSG (HQ100)'},
        {id: '303_1', displayName: 'Anpassung des Flächennutzungsplans'},
        {id: '303_2', displayName: 'Anpassung der Bebauungspläne'},
        {id: '304', displayName: 'Maßnahmen zur hochwasserangepassten Flächennutzung'},
        {id: '309_1', displayName: 'Anpassung des Landschaftsplans'},
        {id: '309_2', displayName: 'Anpassung des Landschaftsrahmenplans'},
      ];
    case 12: // Vermeidung - Vermeidung
      return [
        {id: '305', displayName: 'Entfernung/Rückbau von hochwasserempfindlichen Nutzungen bzw. Objekten in Überschwemmungsgebieten und/oder Verlegung in Gebiete mit niedrigerer Hochwasserwahrscheinlichkeit'},
        {id: '309_3', displayName: 'Maßnahmen zur Unterstützung der Vermeidung von Hochwasserrisiken/Erstellung von lokalen/regionalen Studien, Gutachten'}         
      ];
    case 13: // Vermeidung - Bauvorsorge
      return [
        {id: '306', displayName: 'Hochwasserangepasstes Bauen und Sanieren'},
        {id: '307', displayName: 'Objektschutz (nachträglich) an Gebäuden und Infrastruktureinrichtungen'},
        {id: '308', displayName: 'Hochwasserangepasster Umgang mit wassergefährdenden Stoffen einschl. Beratung'}
      ];
    case 21: // Schutz - Natürlicher Wasserrückhalt   
      return [
        {id: '310', displayName: 'Hochwassermindernde Flächenbewirtschaftung'},
        {id: '311', displayName: 'Gewässer- und Auenrenaturierung (mit positiven Wirkungen auf den Hochwasserschutz)'},
        {id: '312', displayName: 'Minderung der Flächenversiegelung'},
        {id: '313', displayName: 'Regenwassermanagement'},
        {id: '314', displayName: 'Wiedergewinnung von natürlichen Rückhalteflächen'},        
      ]
    case 22: // Schutz - Technischer Hochwasserschutz   
      return [ 
        {id: '315', displayName: 'Technischer Hochwasserrückhalt - Neubau/Erweiterung'},
        {id: '315_J', displayName: 'Technischer Hochwasserrückhalt - Neubau/Erweiterung gewidmeter Anlagen'},
        {id: '316_1', displayName: 'Neuaufstellung/Fortschreibung/Optimierung von Betriebsplänen'},
        {id: '316_2', displayName: 'Technischer Hochwasserrückhalt - Sanierung/Instandsetzung'},
        {id: '316_2J', displayName: 'Technischer Hochwasserrückhalt - Sanierung/Instandsetzung gewidmeter Anlagen'},
        {id: '317', displayName: 'Technischer Linienschutz - Neubau/Ausbau'},
        {id: '317_J', displayName: 'Technischer Linienschutz - Neubau/Ausbau gewidmeter Bauwerke'},
        {id: '318', displayName: 'Technischer Linienschutz - Sanierung/Instandsetzung'},
        {id: '318_J', displayName: 'Technischer Linienschutz - Sanierung / Instandsetzung gewidmeter Bauwerke'},
        {id: '320', displayName: 'Gewässerunterhaltung und Vorlandmanagement'},
        {id: '321', displayName: 'Hochwasserschutzkonzepte'},
        {id: '319', displayName: 'Vergrößerung des Hochwasser- /Abflussquerschnitts'}      
      ]
      case 31: // Vorsorge - Informationsvorsorge   
        return [
          {id: '322', displayName: 'Hochwasser-/Sturmflutvorhersage und -meldung'},
          {id: '323', displayName: 'Kommunale Warn- und Informationssysteme'},
          {id: '325_1', displayName: 'Durchführung eines Audits Hochwasser'},
        ]
      case 32: // Vorsorge - Verhaltensvorsorge
        return [
          {id: '325_2', displayName: 'Aufklärungsmaßnahmen über Hochwasserrisiken'}
        ]
      case 33: // Vorsorge - Gefahrenabwehr und Katastrophenschutz
        return [
          {id: '324_1', displayName: 'Katastrophenschutzpläne'},
          {id: '324_2', displayName: 'örtliche Alarm-/Einsatz- bzw. Gefahrenabwehrpläne Hochwasser'},
          {id: '324_3', displayName: 'Deichverteidigungsordnung'},
          {id: '324_4', displayName: 'Deichverteidigungspläne'},
          {id: '324_5', displayName: 'Übungen'},
          {id: '324_6', displayName: 'Schulungen (Hochwasserschutz/Deichverteidigung)'},
          {id: '324_7', displayName: 'Bereitstellung von Personal- und Sachressourcen für das Krisenmanagement '}
        ]
      case 34: // Vorsorge - Risikovorsorge
        return [
          {id: '326', displayName: 'Risikovorsorge'}
        ]
      case 41: // Wiederherstellung/ Regeneration und Überprüfung - Wiederherstellung/ Regeneration und Überprüfung
        return [
          {id: '327', displayName: 'Schadensnachsorge'},
          {id: '328', displayName: 'Sonstige Maßnahmen aus dem Bereich Wiederherstellung, Regeneration und Überprüfung'}
        ]
      case 51: // Konzeptionelle Maßnahmen - Flächenvorsorge
        return [
          {id: '501_2', displayName: 'Aufstellung/Anpassung des Landschaftsprogramms'}
        ]
      case 52: // Konzeptionelle Maßnahmen - Konzeptionelle Maßnahmen
        return [
          {id: '501', displayName: 'Erstellung von landesweiten oder gebietsunabhängigen Konzeptionen/Studien/Gutachten (APSFR-unabhängig)'},
          {id: '502', displayName: 'Durchführung von Forschungs-, Entwicklungs- und Demonstrationsvorhaben'},
          {id: '503', displayName: 'Gebietsunabhängige oder landesweite Informations- und Fortbildungsmaßnahmen'},
          {id: '504', displayName: 'Gebietsunabhängige oder landesweite Beratungsmaßnahmen'},
          {id: '505', displayName: 'Einrichtung bzw. Anpassung von Förderprogrammen'},
          {id: '506', displayName: 'Freiwillige Kooperationen'},
          {id: '507', displayName: 'Zertifizierungssysteme'},
          {id: '508', displayName: 'Vertiefende Untersuchungen und Kontrollen'},
          {id: '509', displayName: 'Landesweite Untersuchungen zum Klimawandel'},
          {id: '511', displayName: 'Unterstützung eines kommunalen Starkregenrisikomanagements'}          
      ]
      case 61: // Sonstiges - Sonstige
        return [
          {id: '329', displayName: 'Sonstige Maßnahmen'}
        ]
      case 7777: // Verzicht auf die Meldung einer Maßnahme - Fehlmeldung
      return [
        {id: '7777', displayName: 'Fehlmeldung'}
      ]
    default:
      return Array<ISelection>();
  }
}


export const getStatusImplementation = (actionField: number) => {
  const notStarted =  {id: 'NS', displayName: 'Noch nicht begonnen'};
  const ongoingConstruction = {id: 'OGC', displayName: 'Angelaufen (einmalig)'};
  const completed = {id: 'COM', displayName: 'Abgeschlossen'};
  const abandoned = {id: 'AB', displayName: 'Abgebrochen/ Unterbrochen'}; // in second report cycle "CA" was used instead of "AB"
  const ongoing = {id: 'OGM', displayName: 'Fortlaufend'};
  if (actionField === 22) { // Schutz - Technischer Hochwasserschutz
    return [
      notStarted,
      {id: 'POG', displayName: 'In Vorbereitung'},
      ongoingConstruction,
      completed,
      abandoned,
      ongoing   
    ]
  }
  else if (actionField === 7777){ // Fehlmeldung
    return [completed]
  }
  else {
    return [
      notStarted,
      ongoingConstruction,
      completed,
      abandoned,
      ongoing
    ]
  }
}

export const getStatusImplementationName = (id: string) => {
  switch (id){
    case "NS": return "Noch nicht begonnen";
    case "OGC": return "Angelaufen (einmalig)";
    case "COM": return "Abgeschlossen";
    case "AB":
    case "CA": return "Abgebrochen/ Unterbrochen";
    case "OGM": return "Fortlaufend";
    case "POG": return "In Vorbereitung";
    default:
      return "";
  }
}